import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { orderTags } from '../../resources/orderResources';
import { OrderForListing } from '../../models/OrderForListing';

interface IOrderPopoverProps {
  orderForListing: OrderForListing;
}

export const OrderPopover: React.FC<IOrderPopoverProps> = ({
  orderForListing
}) => {

  let iconColor = 'orange';
  if (orderForListing._preSaleSport) {
    iconColor = orderTags.pre_sale_sport.css.primaryColor;
  }
  if (orderForListing._externallyChanged) {
    iconColor = orderTags.externally_changed.css.primaryColor;
  }

  return orderForListing._informations && orderForListing._informations.length > 0 ?
    <span style={{ marginLeft: '5px' }}>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip>
          {orderForListing._informations.map((information, nindex) => {
            return (
              <div key={`order-information-${orderForListing.order.id}-${nindex}`} style={{ textAlign: 'left' }}>{information}</div>
            );
          })}
        </Tooltip>}
      >
        <span><FontAwesomeIcon icon={faInfoCircle} color={iconColor} size='sm' /></span>
      </OverlayTrigger>
    </span>
  : null;

}